import { useGlobalState } from '../../../state/state';
import { Box, Button, Icon } from '@ace-clublabs/shared-component-library';
import { generateMembershipCardUrl } from '../../../utils/generateURL';

export interface MembershipCardCTAProps {
  visible?: boolean;
}

export const MembershipCardCTA = (props: MembershipCardCTAProps) => {
  const { visible } = props;
  const [membershipDetails] = useGlobalState('memberDetails');
  const clubCode = membershipDetails.clubCode ?? '004';

  if (visible !== undefined && visible === false) {
    return <></>;
  }

  return (
    <Box>
      <Button
        variant="tile"
        label="Membership card"
        startIcon={<Icon iconName="membership-card-solid" />}
        id="MembershipCardCTA"
        onClick={() => {
          window.open(generateMembershipCardUrl(), '_blank');
        }}
        sx={{ background: 'white', whiteSpace: 'nowrap' }}
      />
    </Box>
  );
};

// https://uatmvc.calif.aaa.com/aceapps/replacementcard/request
// https://apps.calif.aaa.com/aceapps/replacementcard/request
